<svelte:options runes={true} />

<script lang="ts">
  import { localeManager } from '@reactive';
  import '@shoelace-style/shoelace/dist/components/button/button.js';
  import '@shoelace-style/shoelace/dist/components/divider/divider.js';
  import '@shoelace-style/shoelace/dist/components/dropdown/dropdown.js';
  import '@shoelace-style/shoelace/dist/components/menu-item/menu-item.js';
  import '@shoelace-style/shoelace/dist/components/menu/menu.js';
  import Icon from './Icon.svelte';
  import type { MenuItem, MenuLabel } from './menu-types.js';

  let {
    items,
    label
  }: {
    items: MenuItem[];
    label: MenuLabel;
  } = $props();

  function handleSelect(event: CustomEvent) {
    const selectedItem = (event.detail as { item: HTMLElement }).item;
    const value = selectedItem.getAttribute('value') ?? selectedItem.textContent ?? '';
    console.log('Selected menu item:', value);
  }
</script>

<style>
  :global(.menu-trigger) {
    --sl-spacing-x-small: 8px;
    --sl-spacing-small: 12px;
    border-radius: 0;
    border: none;
  }

  :global(.menu-trigger:hover) {
    background-color: var(--sl-color-neutral-100);
  }

  :global(.menu-trigger:focus-visible) {
    outline: 2px solid var(--sl-color-primary-600);
    outline-offset: -2px;
  }
</style>

<sl-dropdown>
  <sl-button slot="trigger" class="menu-trigger" size="small" variant="text">
    {#if 'labelId' in label}
      {localeManager.localizedString(label.labelId)}
    {:else if 'icon' in label}
      <Icon icon={label.icon} inline />
    {/if}
  </sl-button>

  <sl-menu onsl-select={handleSelect}>
    {#each items as item}
      {#if item.divider}
        <sl-divider></sl-divider>
      {:else}
        <sl-menu-item
          checked={item.checked ?? false}
          disabled={item.disabled ?? false}
          type={item.type ?? 'normal'}
          value={item.value ?? item.label.toLowerCase().replace(/\s+/g, '-')}
        >
          {item.label}
        </sl-menu-item>
      {/if}
    {/each}
  </sl-menu>
</sl-dropdown>
